import React, { useEffect } from "react";
import Loader from "./Loader";
const Index = ({ title }) => {
  useEffect(() => {
    document.title = title; // Set the document title
    window.location.href = "/default.php"; // Redirect to /default.php
  }, [title]);

  return <div><Loader/></div>;
};

export default Index;
